<template lang="">
    <div>
        <p>error</p>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>